import { VariableLayerItemListCombinedProps } from './types';

const usePresenter = (props: VariableLayerItemListCombinedProps): VariableLayerItemListCombinedProps => {
  return props;
};

export default usePresenter;
